import React, { FC, useEffect, useState } from 'react';
import { IDialogProps } from '../types';

import {
  StyledDialog,
  DialogPanel,
  DialogHeader,
  DialogTitle,
  DialogContent,
  DialogActions
} from './styled';

import { DialogProps as MuiDialogProps } from '@mui/material';
import { IconClose } from '@mzc-cloudplex/icons';
import { IconButton } from '../icon-button';

type extendedDialogProps = IDialogProps & MuiDialogProps;

export const Dialog: FC<extendedDialogProps> = ({
  open,
  width,
  maxWidth,
  fullWidth,
  onClose,
  modalTitle,
  children,
  actions,
  type,
  onClickClose,
  headerClose,
  panel,
  panelOpen,
  panelExpand
}) => {
  const [topDivider, setTopDivider] = useState(false);
  const [bottomDivider, setBottomDivider] = useState(false);

  const initializeDividers = () => {
    setTopDivider(false);
    setBottomDivider(false);

    const dialogContent = document.getElementById('dialog-content');

    if (dialogContent !== null) {
      if (dialogContent.scrollHeight > dialogContent.clientHeight) {
        setBottomDivider(true);
      }
    }
  };

  const handleScrolling = (e: React.UIEvent<HTMLDivElement>) => {
    if (e === undefined) {
      return;
    }
    const { scrollTop, scrollHeight, offsetHeight } = e.currentTarget;

    setTopDivider(scrollTop !== 0);
    setBottomDivider(scrollTop !== scrollHeight - offsetHeight);
  };

  useEffect(() => {
    if (open) {
      initializeDividers();
    }
  }, [open]);

  return (
    <StyledDialog
      open={open}
      onClose={onClose}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      scroll={'paper'}
      type={type}
      width={width}
      panel={panel}
      panelOpen={panelOpen}
      panelExpand={panelExpand}
    >
      {headerClose ? (
        <DialogHeader className={`dialog-header ${topDivider ? 'sticky' : ''}`}>
          {modalTitle && <DialogTitle {...({ component: 'div' } as any)}>{modalTitle}</DialogTitle>}
          <IconButton
            size={'medium'}
            variant={'text'}
            color={'secondary'}
            circled
            onClick={onClickClose}
          >
            <IconClose size={16} />
          </IconButton>
        </DialogHeader>
      ) : (
        <>
          {modalTitle && <DialogTitle {...({ component: 'div' } as any)}>{modalTitle}</DialogTitle>}
        </>
      )}

      {/*{topDivider ? <><Divider /></> : null}*/}
      <DialogContent onScroll={handleScrolling}>{children}</DialogContent>
      {/*{bottomDivider ? <Divider /> : null}*/}
      {actions && <DialogActions>{actions}</DialogActions>}
      {panel && (
        <DialogPanel
          open={panelOpen}
          PaperProps={{
            style: {
              position: 'absolute',
              height: `100%`,
              width: panelExpand ? `100%` : undefined
            }
          }}
          variant={'permanent'}
          anchor='right'
        >
          {panel}
        </DialogPanel>
      )}
    </StyledDialog>
  );
};
